import { Cloud, ExternalLink, FolderPlus, HardDrive } from 'lucide-react';

import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { SITE_BASE_URL } from '../../../config/env';

interface PromptsToolbarProps {
  searchFilter: string;
  isCloudSource: boolean;
  onSearchFilterChange: (value: string) => void;
  onCreateFolder: () => void;
}

function DataSourceIndicator({ isCloud }: Readonly<{ isCloud: boolean }>) {
  return (
    <div
      className="flex shrink-0 items-center gap-1.5 text-xs text-muted-foreground"
      title={isCloud ? 'Syncing with cloud' : 'Saved locally'}
    >
      {isCloud ? (
        <>
          <Cloud className="h-3.5 w-3.5" />
          <span>Cloud</span>
        </>
      ) : (
        <>
          <HardDrive className="h-3.5 w-3.5" />
          <span>Local</span>
        </>
      )}
    </div>
  );
}

export default function PromptsToolbar({
  searchFilter,
  isCloudSource,
  onSearchFilterChange,
  onCreateFolder,
}: Readonly<PromptsToolbarProps>): JSX.Element {
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1">
        <Input
          type="text"
          placeholder="Search prompts..."
          value={searchFilter}
          onChange={(event) => onSearchFilterChange(event.target.value)}
        />
      </div>
      <DataSourceIndicator isCloud={isCloudSource} />
      <Button
        variant="outline"
        size="sm"
        type="button"
        onClick={() => window.open(`${SITE_BASE_URL}/marketplace`, '_blank', 'noopener,noreferrer')}
        className="shrink-0"
      >
        <ExternalLink className="h-4 w-4" />
        <span className="hidden sm:inline">Browse Marketplace</span>
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onCreateFolder}
        aria-label="Create new folder"
        className="shrink-0"
      >
        <FolderPlus className="h-4 w-4" />
      </Button>
    </div>
  );
}
